<template>
  <div
    ref="select"
    class="select"
    :class="{
      open: open,
    }"
  >
    <!-- <Transition name="fade" mode="out-in"> -->
    <span :lastKey="title" v-show="title" class="select__title">{{
      title
    }}</span>
    <!-- </Transition> -->
    <div class="select__selected" @click="open = !open">
      <!-- <Transition name="fade" mode="out-in"> -->
      <!-- <img
        @load="resolveAsset($event)"
        :lastKey="optionSel.cod"
        v-show="optionSel.icon"
        :src="optionSel.icon"
        alt=""
        class="select__selected__icon"
      /> -->
      <!-- </Transition> -->
      <!-- <Transition name="fade" mode="out-in"> -->
      <span
        :lastKey="optionSel.cod + language"
        class="select__selected__option"
        >{{ optionSel.getLiteral(language) }}</span
      >
      <!-- </Transition> -->
      <img
        @load="resolveAsset($event)"
        v-show="icon"
        :src="icon"
        alt=""
        class="select__selected__dropdown"
      />
    </div>
    <ul class="select__options" :style="optionsHeight">
      <li
        v-for="(option, index) in valores"
        :key="index"
        class="select__options__item"
        :class="{
          active: option.cod == valorSel,
        }"
        @click="setOption(option)"
      >
        <!-- <img
          @load="resolveAsset($event)"
          v-show="option.icon"
          :src="option.icon"
          alt=""
          class="select__options__item__icon"
        /> -->
        <!-- <Transition name="fade" mode="out-in"> -->
        <span :lastKey="language" class="select__options__item__text">{{
          option.getLiteral(language)
        }}</span>
        <!-- </Transition> -->
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Select',
  props: {
    language: {
      type: String,
      default: 'es',
    },
    borderRadius: {
      type: String,
      default: '0px',
    },
    title: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: () => require('@/assets/images/iconos/arrow.svg'),
    },
    valorSel: {
      type: String,
      default: '',
    },
    valores: {
      type: Array,
      default: [],
    },
    activeColor: {
      type: String,
      default: 'black',
    },
    hoverColor: {
      type: String,
      default: '#e6e6e6',
    },
    hoverTextColor: {
      type: String,
      default: 'black',
    },
  },
  data() {
    return {
      open: false,
    };
  },
  created() {
    document.addEventListener('click', this.setOutsideSelectEvent);
  },
  destroyed() {
    document.removeEventListener('click', this.setOutsideSelectEvent);
  },
  computed: {
    optionSel() {
      return this.valores[
        this.valores.findIndex((valorEl) => valorEl.cod == this.valorSel)
      ];
    },
    optionsHeight() {
      return this.open
        ? `height: ${this.valores.length * 33}px;`
        : 'height: 0px;';
    },
  },
  methods: {
    setOutsideSelectEvent() {
      if (!this.$refs.select.contains(event.target)) {
        this.open = false;
      }
    },
    setOption(option) {
      if (option.cod != this.valorSel) {
        this.$emit('valor', option.cod);
      }
      this.open = false;
    },
  },
};
</script>

<style scoped lang="scss">
.select {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  &__title {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 10px;
  }
  &__selected {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 30px;
    background-color: #ffffff;
    box-sizing: border-box;
    border-radius: v-bind(borderRadius);
    padding: 0px 15px;
    -webkit-transition: 0.35s ease-in-out border-radius;
    -moz-transition: 0.35s ease-in-out border-radius;
    -ms-transition: 0.35s ease-in-out border-radius;
    -o-transition: 0.35s ease-in-out border-radius;
    transition: 0.35s ease-in-out border-radius;
    &__icon {
      opacity: 0;
      width: 15px;
      height: auto;
      object-fit: contain;
      margin-right: 10px;
      -webkit-transition: 0.35s ease-in-out opacity;
      -moz-transition: 0.35s ease-in-out opacity;
      -ms-transition: 0.35s ease-in-out opacity;
      -o-transition: 0.35s ease-in-out opacity;
      transition: 0.35s ease-in-out opacity;
    }
    &__option {
      font-size: 13px;
    }
    &__dropdown {
      opacity: 0;
      width: 20px;
      height: 20px;
      object-fit: contain;
      margin-left: 10px;
      transform: rotate(0deg);
      -webkit-transition:
        0.35s ease-in-out transform,
        0.35s ease-in-out opacity;
      -moz-transition:
        0.35s ease-in-out transform,
        0.35s ease-in-out opacity;
      -ms-transition:
        0.35s ease-in-out transform,
        0.35s ease-in-out opacity;
      -o-transition:
        0.35s ease-in-out transform,
        0.35s ease-in-out opacity;
      transition:
        0.35s ease-in-out transform,
        0.35s ease-in-out opacity;
    }
  }
  &__options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #ffffff;
    border-top: none;
    height: 0px;
    overflow-y: auto;
    z-index: 10000;
    width: 100%;
    max-height: 200px;
    border-radius: 0px 0px v-bind(borderRadius) v-bind(borderRadius);
    &::-webkit-scrollbar {
      display: none;
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 100px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: rgba(0, 0, 0, 0.5);
    }
    @media (hover: hover) {
      &::-webkit-scrollbar {
        display: block;
      }
    }
    -webkit-transition: 0.35s ease-in-out height;
    -moz-transition: 0.35s ease-in-out height;
    -ms-transition: 0.35s ease-in-out height;
    -o-transition: 0.35s ease-in-out height;
    transition: 0.35s ease-in-out height;
    &__item {
      cursor: pointer;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      background-color: #ffffff;
      padding: 10px;
      -webkit-transition: 0.35s ease-in-out background-color;
      -moz-transition: 0.35s ease-in-out background-color;
      -ms-transition: 0.35s ease-in-out background-color;
      -o-transition: 0.35s ease-in-out background-color;
      transition: 0.35s ease-in-out background-color;
      &__icon {
        opacity: 0;
        filter: invert(0%);
        width: 15px;
        height: auto;
        object-fit: contain;
        margin-right: 10px;
        -webkit-transition:
          0.35s ease-in-out filter,
          0.35s ease-in-out opacity;
        -moz-transition:
          0.35s ease-in-out filter,
          0.35s ease-in-out opacity;
        -ms-transition:
          0.35s ease-in-out filter,
          0.35s ease-in-out opacity;
        -o-transition:
          0.35s ease-in-out filter,
          0.35s ease-in-out opacity;
        transition:
          0.35s ease-in-out filter,
          0.35s ease-in-out opacity;
      }
      &__text {
        color: black;
        font-size: 13px;
        -webkit-transition: 0.35s ease-in-out color;
        -moz-transition: 0.35s ease-in-out color;
        -ms-transition: 0.35s ease-in-out color;
        -o-transition: 0.35s ease-in-out color;
        transition: 0.35s ease-in-out color;
      }
      @media (hover: hover) {
        &:not(.active):hover {
          background-color: v-bind(hoverColor);
          -webkit-transition: 0.35s ease-in-out background-color;
          -moz-transition: 0.35s ease-in-out background-color;
          -ms-transition: 0.35s ease-in-out background-color;
          -o-transition: 0.35s ease-in-out background-color;
          transition: 0.35s ease-in-out background-color;
          & .select__options__item {
            &__text {
              color: v-bind(hoverTextColor);
              -webkit-transition: 0.35s ease-in-out color;
              -moz-transition: 0.35s ease-in-out color;
              -ms-transition: 0.35s ease-in-out color;
              -o-transition: 0.35s ease-in-out color;
              transition: 0.35s ease-in-out color;
            }
          }
        }
      }
      &.active {
        color: white;
        background-color: v-bind(activeColor);
        -webkit-transition: 0.35s ease-in-out background-color;
        -moz-transition: 0.35s ease-in-out background-color;
        -ms-transition: 0.35s ease-in-out background-color;
        -o-transition: 0.35s ease-in-out background-color;
        transition: 0.35s ease-in-out background-color;
        & .select__options__item {
          &__icon {
            opacity: 0;
            filter: invert(100%);
            -webkit-transition:
              0.35s ease-in-out filter,
              0.35s ease-in-out opacity;
            -moz-transition:
              0.35s ease-in-out filter,
              0.35s ease-in-out opacity;
            -ms-transition:
              0.35s ease-in-out filter,
              0.35s ease-in-out opacity;
            -o-transition:
              0.35s ease-in-out filter,
              0.35s ease-in-out opacity;
            transition:
              0.35s ease-in-out filter,
              0.35s ease-in-out opacity;
          }
          &__text {
            color: white;
            -webkit-transition: 0.35s ease-in-out color;
            -moz-transition: 0.35s ease-in-out color;
            -ms-transition: 0.35s ease-in-out color;
            -o-transition: 0.35s ease-in-out color;
            transition: 0.35s ease-in-out color;
          }
        }
      }
    }
  }
  &.open {
    border-radius: v-bind(borderRadius) v-bind(borderRadius) 0px 0px;
    -webkit-transition: 0.35s ease-in-out border-radius;
    -moz-transition: 0.35s ease-in-out border-radius;
    -ms-transition: 0.35s ease-in-out border-radius;
    -o-transition: 0.35s ease-in-out border-radius;
    transition: 0.35s ease-in-out border-radius;
    & .select {
      &__selected {
        border-radius: v-bind(borderRadius) v-bind(borderRadius) 0px 0px;
        -webkit-transition: 0.35s ease-in-out border-radius;
        -moz-transition: 0.35s ease-in-out border-radius;
        -ms-transition: 0.35s ease-in-out border-radius;
        -o-transition: 0.35s ease-in-out border-radius;
        transition: 0.35s ease-in-out border-radius;
        &__icon {
        }
        &__option {
        }
        &__dropdown {
          transform: rotate(-180deg);
          -webkit-transition: 0.35s ease-in-out transform;
          -moz-transition: 0.35s ease-in-out transform;
          -ms-transition: 0.35s ease-in-out transform;
          -o-transition: 0.35s ease-in-out transform;
          transition: 0.35s ease-in-out transform;
        }
      }
    }
  }
}
</style>
